import React, { useContext, useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Form from 'react-bootstrap/Form';
import HighneckDisplay from "./highdisplay";
import { ChudidharContext } from "../../../../context/chudidharContext";
import { useTranslation } from 'react-i18next';


const ChudiDefaultHighNecks=()=>{
      const {chudiHighNeckData}=useContext(ChudidharContext);
      const [filterData,setFilterData]=useState("");
      const { t } = useTranslation();

    const getFilterData=chudiHighNeckData && chudiHighNeckData.filter(each=>(
      each.name.toLowerCase().includes(filterData.toLowerCase())
    ))

    
    return(
        <>
         <div className="d-flex mt-2">
                <Col className="" lg={7}>
                   <Form.Control type="text" placeholder="Search By Items..."
                   onChange={(e)=>setFilterData(e.target.value)} />
                 </Col>
                 <Col className="mx-2 mt-2" lg={5}>
                   <p className="text-dark ">{t('main.search_total')} {getFilterData && getFilterData.length}</p>
                 </Col>
            </div>
           
            <div className="leftside_items_sleeve" >
                 {getFilterData?.map(each=>(
                  <HighneckDisplay key={each.id}
                  icon={each.icon}
                  name={each.name}
                  data={each}>
                  </HighneckDisplay>
                 ))}
                 
            </div>
        </>
    )
}
export default ChudiDefaultHighNecks